const getUrlParameter = (name: string, locationSearch: string): string => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp(`[?&]${name}=([^&#]*)`)
  const results = regex.exec(locationSearch)

  return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : ''
}

// TODO get some tests done for this
const getParam = (search: string) => (param: string): string => {
  if (typeof window === 'undefined') {
    return ''
  }

  if (typeof URLSearchParams === 'undefined') {
    return getUrlParameter(param, search)
  } else {
    const urlParams = new URLSearchParams(search)

    return urlParams.get(param) || getUrlParameter(param, search)
  }
}

export default getParam
